import * as React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
const WarningIcon = styled(Icon)`
  margin-right: 5px;
`;
const WidgetTitle = ({
  title,
  isLoading,
  detailsAreAvailable
}) => {
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "Loading...");
  }
  if (!detailsAreAvailable) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(WarningIcon, { name: "warning" }), /* @__PURE__ */ React.createElement("i", null, "Widget not accessible"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};
export default WidgetTitle;
